import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';

const abvGtnSideNav = {
  id: 'gtn',
  children: [
    // Actuals Menu
    {
      id: 'gtnActuals',
      displayName: 'Actuals',
      icon: fas.faFileInvoiceDollar,
      role: 'GTN_VIEW',
      children: [
        {
          id: 'gtnGtnSales',
          displayName: 'GTN Sales',
          role: 'GTN_GTN_SALES_VIEW',
          route: 'gtn/gtn-sales',
          state: { mode: Mode.PERSPECTIVE },
        },
        {
          id: 'gtnSapActuals',
          displayName: 'SAP Actuals',
          role: 'GTN_SAP_ACTUALS_VIEW',
          route: 'gtn/sap-actuals',
          state: { mode: Mode.PERSPECTIVE },
        },
        {
          id: 'gtnSapRecon',
          displayName: 'SAP Reconciliation',
          role: 'GTN_SAP_RECON_VIEW',
          route: 'gtn/sap-recon',
          state: { mode: Mode.PERSPECTIVE },
        },
        {
          id: 'gtnManAccrAdj',
          displayName: 'Manual Accrual Adjustments',
          role: 'GTN_MAN_ACCR_ADJ_VIEW',
          route: 'gtn/man-accr-adj',
        },
        {
          id: 'gtnReserve',
          displayName: 'Reserve',
          role: 'GTN_RESERVE_VIEW',
          route: 'gtn/reserve',
          state: { mode: Mode.PERSPECTIVE },
        },
        {
          id: 'gtnChbkPymt',
          displayName: 'Chargeback Payments',
          role: 'GTN_CHBK_PYMT_VIEW',
          route: 'gtn/chbk-pymt',
          state: { mode: Mode.PERSPECTIVE },
        },
        {
          id: 'gtnMcdPymtActuals',
          displayName: 'Medicaid Payments',
          role: 'GTN_MCD_PYMT_ACTUALS_VIEW',
          route: 'gtn/mcd-pymt-actuals',
          state: { mode: Mode.PERSPECTIVE },
        },
        {
          id: 'gtnPbmPymt',
          displayName: 'PBM Payments',
          role: 'GTN_PBM_PYMT_VIEW',
          route: 'gtn/pbm-pymt',
          state: { mode: Mode.PERSPECTIVE },
        },
      ],
    },
    // Over/(Under) Scenario Menu
    {
      id: 'gtnOverUnderMenu',
      displayName: 'Over/(Under)',
      role: 'GTN_VIEW',
      children: [
        {
          id: 'gtnOverUnderScen',
          displayName: 'Scenarios',
          role: 'GTN_OVER_UNDER_SCEN_VIEW',
          route: 'gtn/over-under-scen',
        },
        { id: 'gtnLbe', displayName: 'LBEs', role: 'GTN_LBE_VIEW', route: 'gtn/lbe' },
        {
          id: 'gtnPipeDayGrp',
          displayName: 'Pipeline Day Groups',
          role: 'GTN_PIPE_DAY_GRP_VIEW',
          route: 'gtn/pipe-day-grp',
        },
        {
          id: 'gtnMcdPymtActualsSplitGrp',
          displayName: 'Medicaid Splits',
          role: 'GTN_MCD_PYMT_ACTUALS_SPLIT_GRP_VIEW',
          route: 'gtn/mcd-pymt-actuals-split-grp',
        },
        {
          id: 'gtnPriceActionPctGrp',
          displayName: 'Price Action Percent Groups',
          role: 'GTN_PRICE_ACTION_PCT_GRP_VIEW',
          route: 'gtn/price-action-pct-grp',
        },
      ],
    },
    // Maps Menu
    {
      id: 'gtnMaps',
      displayName: 'Maps',
      children: [
        { id: 'gtnCeCode', displayName: 'CE Codes', role: 'GTN_CE_CODE_VIEW', route: 'gtn/ce-code' },
        { id: 'gtnPlan', displayName: 'Plans', role: 'GTN_PLAN_VIEW', route: 'gtn/plan' },
        {
          id: 'gtnUniqueClient',
          displayName: 'Unique Clients',
          role: 'GTN_UNIQUE_CLIENT_VIEW',
          route: 'gtn/unique-client',
        },
        { id: 'gtnPbmMap', displayName: 'PBM Maps', role: 'GTN_PBM_MAP_VIEW', route: 'gtn/pbm-map' },
        { id: 'gtnGlAcctMap', displayName: 'G/L Account Maps', role: 'GTN_GL_ACCT_MAP_VIEW', route: 'gtn/gl-acct-map' },
      ],
    },
  ],
};

export default abvGtnSideNav;
